<template>
    <div ref="iframe">
        <slot name="terms-alert" v-bind="this"></slot>
    </div>
</template>

<script>
export default {
    props: {
        icon: { type: String, required: true},
        confirmButtonText: { type: String, required: true },
        confirmButton:{ type: String, required: true },
        cancelButton: { type: String, required: true },
        modalStyle: { type: String, required: true }
    },
    data() {
        return {
            termsAccepted: false
        }
    },
    computed: {
        imageUrl() {
            const regex = /src=["']([^"']+)["']/;
            const matches = this.icon.match(regex);
            return matches ? matches[1] : '';
        }
    },
    methods: {

        showAlertTerms() {

                return this.$swal({
                    imageUrl: this.imageUrl,
                    html: this.$refs.iframe,
                    showCancelButton: true,
                    confirmButtonText: this.confirmButtonText,
                    customClass: {
                        popup: this.modalStyle,
                        confirmButton: this.confirmButton,
                        cancelButton: this.cancelButton
                    },
                    allowOutsideClick: false,
                    didOpen: () => {
                        document.body.classList.remove('swal2-height-auto');
                    }
                }).then((result) => {
                    const termsAccepted = result.isConfirmed;
                    if(termsAccepted) {
                        this.$emit('terms-accepted');
                    } else {
                        this.$emit('terms-declined');
                    }
                    return result.isConfirmed;
                });

        }

    },
    mounted() {
        this.showAlertTerms();
    }

}
</script>

